import Button from "@components/ui/Button";
import { ReactNode } from "react";
import { webAuth } from "../../auth0/auth0";
import { useVendorContext } from "@contexts/vendor-context";
import { useRouter } from "next/router";
import { createOauthQuerystringParams } from "@lib/oauth-query-string-keys";
import cn from "classnames";
import { datadogLogs } from "@datadog/browser-logs";

const handleSocialLogin = (
  connection: string,
  responseType: string,
  state: string,
  event: string,
) => {
  datadogLogs.logger.info(event, { connection });

  webAuth.authorize({
    connection,
    responseType,
    state,
  });
};

type Props = {
  social: string;
  icon: ReactNode;
  text: string;
  canResize?: boolean;
};

const SocialButton = ({
  social,
  text,
  icon = null,
  canResize = false,
}: Props) => {
  const router = useRouter();
  const { responseType } = useVendorContext();
  const state = createOauthQuerystringParams(router.query);

  return (
    <Button
      className={cn(
        "border border-gray-200 bg-white hover:bg-gray-100 dark:border-gray-400 dark:bg-black dark:hover:bg-black/90",
        {
          ["px-0 py-3 sm:px-10 sm:py-4 short:px-0 short:py-3"]: canResize,
          ["px-10 py-3"]: !canResize,
        },
      )}
      variant="custom"
      onClick={() =>
        handleSocialLogin(
          social === "google" ? "google-oauth2" : social,
          responseType,
          state,
          canResize ? "social button" : "social button after email",
        )
      }
      aria-label={text}
    >
      {icon}
      <div
        className={cn("text-left text-black dark:text-white sm:text-base", {
          ["hidden sm:inline short:hidden"]: canResize,
        })}
      >
        {text}
      </div>
    </Button>
  );
};

export default SocialButton;
